document.addEventListener("DOMContentLoaded", () => {
document.body.addEventListener("click", (e) => {
  const btn = e.target.closest(".product-info-svg");
  if (!btn) return;

  // 🔹 Match each trigger to its own drawer/overlay/close-button via data-drawer-group,
  // since the page can contain more than one independent drawer instance (e.g. the main
  // product info panel and the spec-table tab both render their own drawer markup).
  const group = btn.getAttribute("data-drawer-group");

  let drawer = null;
  let overlay = null;
  let closeBtn = null;

  if (group) {
    const groupSuffix = `[data-drawer-group="${group}"]`;
    drawer = document.querySelector(`.product-info-drawer${groupSuffix}`);
    overlay = document.querySelector(`.drawer-overlay${groupSuffix}`);
    closeBtn = document.querySelector(`.drawer-close${groupSuffix}`);
  }

  // 🔹 Fallback for any trigger without a data-drawer-group: match by position
  // among other untagged triggers/drawers, preserving prior behavior.
  if (!drawer || !overlay || !closeBtn) {
    const untaggedBtns = [...document.querySelectorAll(".product-info-svg:not([data-drawer-group])")];
    const index = untaggedBtns.indexOf(btn);

    const untaggedDrawers = document.querySelectorAll(".product-info-drawer:not([data-drawer-group])");
    const untaggedOverlays = document.querySelectorAll(".drawer-overlay:not([data-drawer-group])");
    const untaggedCloseBtns = document.querySelectorAll(".drawer-close:not([data-drawer-group])");

    drawer = untaggedDrawers[index];
    overlay = untaggedOverlays[index];
    closeBtn = untaggedCloseBtns[index];
  }

  if (!drawer || !overlay || !closeBtn) return;

  // 🔹 Get current variant ID
  const variantIdElement = document.querySelector('[data-product-variants]');
  const currentVariantId = variantIdElement ? variantIdElement.getAttribute('data-current-variant-id') : null;

  // 🔹 Show correct SVG content based on variant
  const drawerContent = drawer.querySelector('.drawer-content');
  if (drawerContent) {
    const allSvgContents = drawerContent.querySelectorAll('.drawer-svg-content');
    
    // Hide all contents first
    allSvgContents.forEach(content => {
      content.style.display = 'none';
    });

    // Show variant-specific content if exists, otherwise show product-level fallback
    let contentShown = false;
    if (currentVariantId) {
      const variantContent = drawerContent.querySelector(`[data-variant-id="${currentVariantId}"]`);
      if (variantContent) {
        variantContent.style.display = 'block';
        contentShown = true;
      }
    }

    // If no variant content found, show product-level fallback
    if (!contentShown) {
      const fallbackContent = drawerContent.querySelector('[data-product-svg="true"]');
      if (fallbackContent) {
        fallbackContent.style.display = 'block';
      }
    }
  }

  // 🔹 Open drawer
  drawer.classList.add("open");
  overlay.classList.add("active");
  document.body.classList.add("no-scroll");

  // 🔹 Close drawer (via close icon or overlay)
  const closeDrawer = () => {
    drawer.classList.remove("open");
    overlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
  };

  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);
});

let bdPriceBadgeAbortController = null;
let bdPriceBadgeDebounceTimer = null;

async function updateVariantPriceBadges(variant) {
  if (!variant) return;

  const productSection = document.querySelector('.bd-product[data-section-id]');
  const hasTimerBlock = document.querySelector('[data-percentage-timer]');
  const hasMediaBadges = document.querySelector('.product-sale-badge-timer');
  if (!productSection || (!hasTimerBlock && !hasMediaBadges)) return;

  clearTimeout(bdPriceBadgeDebounceTimer);
  if (bdPriceBadgeAbortController) bdPriceBadgeAbortController.abort();

  bdPriceBadgeDebounceTimer = setTimeout(() => {
    fetchAndApplyVariantPriceBadges(productSection, variant);
  }, 200);
}

async function fetchAndApplyVariantPriceBadges(productSection, variant) {
  const controller = new AbortController();
  bdPriceBadgeAbortController = controller;

  const sectionId = productSection.getAttribute('data-section-id');
  const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&variant=${encodeURIComponent(variant.id)}`;

  try {
    const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const timerBlock = document.querySelector('[data-percentage-timer]');
    if (timerBlock) {
      const newTimerBlock = doc.querySelector('[data-percentage-timer]');
      if (newTimerBlock) {
        timerBlock.replaceWith(newTimerBlock);
      }
    }

    const mediaBadgeSelector = '.product__media-slider .product-sale-badge-timer, .product__media-item .product-sale-badge-timer';
    const currentMediaBadges = document.querySelectorAll(mediaBadgeSelector);
    const newMediaBadges = doc.querySelectorAll(mediaBadgeSelector);

    currentMediaBadges.forEach((badge, index) => {
      const newBadge = newMediaBadges[index];
      if (newBadge) {
        badge.replaceWith(newBadge);
      }
    });

    document.querySelectorAll('.countdown-timer').forEach((el) => {
      el.timerActive = false;
    });

    updateMediaBadgeVisibility();
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.error('Variant badge update failed:', error);
    }
  }
}

// 🔹 Listen for variant changes and update the data-current-variant-id
document.addEventListener("product:variant-change", function (evt) {
  if (evt.detail && evt.detail.variant) {
    const variantIdElement = document.querySelector('[data-product-variants]');
    if (variantIdElement) {
      variantIdElement.setAttribute('data-current-variant-id', evt.detail.variant.id);
    }

    updateProductBenefits(evt.detail.variant.id);
    updateVariantPriceBadges(evt.detail.variant);
  }

  // [nn-s-12 A/B TEST] Sync update on variant change
  if (evt.detail && evt.detail.variant) {
    nn_s12_log('variant-change', evt.detail.variant.id, evt.detail.variant.options);
    nn_s12_updateForVariant(evt.detail.variant);
  }
  // [nn-s-12 A/B TEST] End

  // Desktop media grid: show only the matching variant's media
  if (evt.detail && evt.detail.variant) {
    updateMediaGridForVariant(evt.detail.variant);
  }
});

function updateProductBenefits(variantId) {
  const container = document.querySelector('[data-product-benefits-container]');
  const content = document.querySelector('[data-product-benefits-content]');
  
  if (!container || !content) return;
  
  const dataElement = document.querySelector('[id^="ProductBenefitsData-"]');
  if (!dataElement) return;
  
  let data;
  try {
    data = JSON.parse(dataElement.textContent);
  } catch (e) {
    console.error('Benefits data parse error:', e);
    return;
  }
  
  let benefits = null;
  
  if (data.variantBenefits[variantId] && data.variantBenefits[variantId].length > 0) {
    benefits = data.variantBenefits[variantId];
  } else if (data.productBenefits && data.productBenefits.length > 0) {
    benefits = data.productBenefits;
  }
  
  if (benefits) {
    content.innerHTML = benefits.map(b => `<p class="paragraph-xs">${b}</p>`).join('');
    container.style.display = '';
  } else {
    container.style.display = 'none';
  }
}


setInterval(function() {
  var timers = document.querySelectorAll('.countdown-timer');
  timers.forEach(function(el) {
    if (!el.timerActive && el.dataset.targetDate) {
      el.timerActive = true;
      var targetDate = new Date(el.dataset.targetDate).getTime();
      
      function updateCountdown() {
        var now = new Date().getTime();
        var distance = targetDate - now;
        if (distance < 0) {
          el.innerHTML = "00:00:00";
          return;
        }
        
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        el.innerHTML =
          (days > 0 ? days + " : " : '') +
          (hours < 10 ? "0" + hours : hours) + " : " +
          (minutes < 10 ? "0" + minutes : minutes) + " : " +
          (seconds < 10 ? "0" + seconds : seconds);
      }
      
      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  });
}, 2000);


  function updatePrices() {
    const checkedRadio = document.querySelector('.js_change_qty:checked');
    if (!checkedRadio) return; 

    var dataPriceElement = document.querySelector('[data-price]');
    var dataComparePriceElement = document.querySelector('[data-compare-price]');

    const baseCurrentPrice = Number(dataPriceElement.getAttribute('data-original_price')) / 100;
    const baseOriginalPrice = Number(dataComparePriceElement.getAttribute('data-original_c_price')) / 100;
    
    const quantity = parseInt(checkedRadio.value, 10) || 1;
    const discountAttribute = parseInt(checkedRadio.getAttribute('data_discount')) || 0;
    const discount = discountAttribute / 100;

    const finalCurrentPrice = (baseCurrentPrice * quantity) - discount;
    const finalOriginalPrice = baseOriginalPrice * quantity;

    dataPriceElement.textContent = window.formatMoney(finalCurrentPrice*100, '${{amount_no_decimals_with_comma_separator}}').replace(',00','');
    dataComparePriceElement.textContent = window.formatMoney(finalOriginalPrice*100, '${{amount_no_decimals_with_comma_separator}}').replace(',00','');
    document.querySelectorAll('[name="quantity"]').forEach(qty => {
        qty.value = quantity;
    });
}

document.addEventListener('change', function (e) {
  if (e.target.classList.contains('js_change_qty')) {
    updatePrices.call(e.target, e);
  }
});



window.addEventListener("load", () => {
  requestAnimationFrame(() => {
    const selectedBtn = document.querySelector('[dynamic-variant-button].selected');
    if (selectedBtn) {
      selectedBtn.click();
      
    } else {
      
    }
  });

  setTimeout(function(){
  const checkedInput = document.querySelector('.js_change_qty:checked');
    if (checkedInput) {
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
 },2000);   

});


document.body.addEventListener('click', function(e) {
  const question = e.target.closest('.facets_questions');
  if (!question) return;
  
  e.preventDefault();

  const answer = question.nextElementSibling;
  const svg = question.querySelector('.facets-label svg');

  if (answer && answer.classList.contains('facets_answers')) {
    const isVisible = answer.style.display === 'flex' || answer.offsetHeight > 0;

    if (isVisible) {
      // Slide up - CLOSING (arrow should point DOWN)
      if (svg) {
        svg.style.transform = 'rotate(0deg)';
        svg.style.transition = 'transform 0.2s ease';
      }
      answer.style.maxHeight = answer.scrollHeight + 'rem';
      requestAnimationFrame(() => {
        answer.style.transition = 'max-height 0.2s ease';
        answer.style.maxHeight = '0';
      });

      requestAnimationFrame(() => {
        answer.style.display = 'none';
      });
      // setTimeout(() => {
      //   answer.style.display = 'none';  
      // }, 200);
    } else {
      // Slide down - OPENING (arrow should point RIGHT)
      if (svg) {
        svg.style.transform = 'rotate(-90deg)';
        svg.style.transition = 'transform 0.2s ease';
      }
      answer.style.display = 'flex';
      answer.style.overflow = 'hidden';
      answer.style.maxHeight = '0';
      requestAnimationFrame(() => {
        answer.style.transition = 'max-height 0.2s ease';
        answer.style.maxHeight = answer.scrollHeight + 'rem';
      });
    }
  }

  const closestDetails = question.closest('details');
  
});



  // [nn-s-12 A/B TEST] Set correct slides before theme.js inits Flickity
  if (document.body.hasAttribute('nn-s-12-ab-test')) {
    var initEl = document.getElementById('nn-s12-ab-init-variant');
    if (initEl && initEl.value) {
      nn_s12_updateForVariant(initEl.value, true);
    }
  } else {
    // [nn-s-12 A/B TEST] Control group: Liquid pre-hides the A slides (and marks the
    // current variant's B slides visible) to avoid FOUC for visitors who turn out to be
    // bucketed into the test. Undo that here for visitors who are NOT in the test, since
    // nn_s12_updateForVariant() (which normally fixes this up) only runs when
    // nn-s-12-ab-test is present, leaving the A gallery permanently hidden otherwise.
    var sliderEl = document.querySelector('.product__media-slider[data-slider]');
    if (sliderEl) {
      sliderEl.querySelectorAll('.product__media-slide.nn-s-12-ab-test-a.is-hidden-by-variant').forEach(function (s) {
        s.classList.remove('is-hidden-by-variant');
      });
      sliderEl.querySelectorAll('.product__media-slide.nn-s-12-ab-test-b').forEach(function (s) {
        s.classList.add('is-hidden-by-variant');
      });

      if (window.Flickity && window.Flickity.data(sliderEl)) {
        nn_s12_rebuildGallery();
      }
    }
    document.body.removeAttribute('nn-s-12-b-active');
  }
  // [nn-s-12 A/B TEST] End

});

function updateMediaBadgeVisibility() {
  const sliderElement = document.querySelector('.product__media-slider[data-slider]');
  if (!sliderElement) return;

  const allSlides = Array.from(sliderElement.querySelectorAll('[data-slide]'));
  let visibleSlides = allSlides.filter((slide) => !slide.classList.contains('is-hidden-by-variant'));
  if (document.body.hasAttribute('nn-s-12-ab-test')) {
    if (document.body.hasAttribute('nn-s-12-b-active')) {
      visibleSlides = visibleSlides.filter((slide) => !slide.classList.contains('nn-s-12-ab-test-a'));
    } else {
      visibleSlides = visibleSlides.filter((slide) => !slide.classList.contains('nn-s-12-ab-test-b'));
    }
  }

  allSlides.forEach((slide) => {
    const badge = slide.querySelector('.product-sale-badge-timer');
    if (badge) badge.style.display = 'none';
  });

  if (visibleSlides.length > 0) {
    const badge = visibleSlides[0].querySelector('.product-sale-badge-timer');
    if (badge) badge.style.display = '';
  }
}

// [nn-s-12 A/B TEST] Variant gallery: show matching slides, rebuild Flickity.
var NN_S12_DEBUG = true;

function nn_s12_log() {
  console.log.apply(console, ['[nn-s-12]'].concat(Array.prototype.slice.call(arguments)));
}

function nn_s12_getCellSelector() {
  var cellSelector = '[data-slide]:not(.is-hidden-by-variant)';
  cellSelector = '[data-slide]:not(.is-hidden-by-variant)';
  if (document.body.hasAttribute('nn-s-12-ab-test')) {
    if (document.body.hasAttribute('nn-s-12-b-active')) {
      cellSelector += ':not(.nn-s-12-ab-test-a)';
    } else {
      cellSelector += ':not(.nn-s-12-ab-test-b)';
    }
  }
  return cellSelector;
}

function nn_s12_normalizeValue(value) {
  return (value || '').replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
}

function nn_s12_getVariantById(variantId) {
  var jsonEl = document.querySelector('[data-variant-json]');
  if (!jsonEl) return null;
  try {
    var variants = JSON.parse(jsonEl.textContent);
    return variants.find(function (v) { return String(v.id) === String(variantId); }) || null;
  } catch (e) {
    return null;
  }
}

function nn_s12_resolveVariant(variantOrId) {
  if (typeof variantOrId === 'object' && variantOrId !== null) return variantOrId;
  var fromJson = nn_s12_getVariantById(variantOrId);
  if (fromJson) return fromJson;
  var initEl = document.getElementById('nn-s12-ab-init-variant');
  if (initEl && String(initEl.value) === String(variantOrId)) {
    return {
      id: initEl.value,
      title: initEl.dataset.title || '',
      option1: initEl.dataset.option1 || null,
      option2: initEl.dataset.option2 || null,
      option3: initEl.dataset.option3 || null,
      options: [initEl.dataset.option1, initEl.dataset.option2, initEl.dataset.option3].filter(Boolean)
    };
  }
  return null;
}

function nn_s12_applyAGallerySlides(variant) {
  var sliderEl = document.querySelector('.product__media-slider[data-slider]');
  if (!sliderEl || !variant) return;

  var selectedValue = nn_s12_normalizeValue(
    (variant.options || []).filter(Boolean).join(' / ')
  );
  var slides = Array.from(sliderEl.querySelectorAll('.product__media-slide.nn-s-12-ab-test-a'));
  var slidesToShow = [];

  slides.forEach(function (slide) {
    var slideVariant = nn_s12_normalizeValue(slide.dataset.variantAlt);
    var matchByData = slideVariant && slideVariant === selectedValue;
    var matchByImg = false;
    slide.querySelectorAll('img[alt]').forEach(function (img) {
      if (nn_s12_normalizeValue(img.getAttribute('alt')) === selectedValue) matchByImg = true;
    });
    if (matchByData || matchByImg) slidesToShow.push(slide);
  });

  if (slidesToShow.length > 0) {
    slides.forEach(function (slide) {
      slide.classList.add('is-hidden-by-variant');
      slide.classList.remove('is-initial-select');
    });
    slidesToShow.forEach(function (slide) {
      slide.classList.remove('is-hidden-by-variant');
    });
    slidesToShow[0].classList.add('is-initial-select');
  } else {
    slides.forEach(function (slide) { slide.classList.remove('is-hidden-by-variant'); });
  }
}

function nn_s12_unwrapFlickityCells(sliderEl) {
  var viewport = sliderEl.querySelector('.flickity-viewport');
  if (!viewport) return;
  var innerSlider = viewport.querySelector('.flickity-slider');
  if (innerSlider) {
    Array.from(innerSlider.children).forEach(function (cell) {
      sliderEl.insertBefore(cell, viewport);
    });
  }
}

function nn_s12_normalizeSliderDom(sliderEl) {
  nn_s12_unwrapFlickityCells(sliderEl);
  var orphanViewport = sliderEl.querySelector('.flickity-viewport');
  if (orphanViewport) orphanViewport.remove();

  var slides = Array.from(sliderEl.querySelectorAll('.product__media-slide[data-slide]'));
  var insertBefore = sliderEl.querySelector('[data-prev]') || sliderEl.querySelector('.carousel-navigation');
  var fragment = document.createDocumentFragment();

  slides.forEach(function (slide) {
    slide.classList.remove('is-selected');
    slide.removeAttribute('style');
    slide.removeAttribute('aria-hidden');
    fragment.appendChild(slide);
  });

  if (insertBefore) {
    sliderEl.insertBefore(fragment, insertBefore);
  } else {
    sliderEl.appendChild(fragment);
  }
}

function nn_s12_unveilVisibleImages(sliderEl) {
  var imgs = sliderEl.querySelectorAll(
    '.product__media-slide:not(.is-hidden-by-variant) img[data-src], ' +
    '.product__media-slide:not(.is-hidden-by-variant) img[d-src]'
  );
  imgs.forEach(function (img) {
    if (window.lazySizes && lazySizes.loader && lazySizes.loader.unveil) {
      lazySizes.loader.unveil(img);
    }
  });
}

function nn_s12_rebuildGallery() {
  var sliderEl = document.querySelector('.product__media-slider[data-slider]');
  if (!sliderEl) return;

  var Flickity = window.Flickity;
  if (!Flickity) {
    nn_s12_log('waiting for Flickity…');
    document.addEventListener('nn-s12:flickity-ready', nn_s12_rebuildGallery, { once: true });
    return;
  }

  var cellSelector = nn_s12_getCellSelector();
  var cells = sliderEl.querySelectorAll(cellSelector);
  nn_s12_log('rebuild gallery, slides:', cells.length);

  if (cells.length === 0) return;

  var flkty = Flickity.data(sliderEl);
  if (flkty) {
    try { flkty.destroy(); } catch (e) { nn_s12_log('destroy error:', e); }
  }

  nn_s12_normalizeSliderDom(sliderEl);
  sliderEl.classList.remove('flickity-enabled', 'is-draggable', 'is-initialed');

  flkty = new Flickity(sliderEl, {
    adaptiveHeight: document.body.hasAttribute('nn-s-12-b-active'),
    cellAlign: 'left',
    cellSelector: cellSelector,
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    watchCSS: false,
    imagesLoaded: true
  });

  flkty.select(0, false, true);
  flkty.resize();
  nn_s12_unveilVisibleImages(sliderEl);

  document.dispatchEvent(new CustomEvent('nn-s12:flickity-rebuilt', {
    detail: { sliderEl: sliderEl, cellCount: flkty.getCellElements().length }
  }));
}

window.nn_s12_getCellSelector = nn_s12_getCellSelector;
window.nn_s12_rebuildGallery = nn_s12_rebuildGallery;

function nn_s12_updateForVariant(variantOrId, skipFlickityRebuild) {
  if (!document.body.hasAttribute('nn-s-12-ab-test')) return;

  var sliderEl = document.querySelector('.product__media-slider[data-slider]');
  if (!sliderEl) return;

  var variant = nn_s12_resolveVariant(variantOrId);
  if (!variant) return;

  var variantId = String(variant.id);
  var bSlides = sliderEl.querySelectorAll(
    '.product__media-slide.nn-s-12-ab-test-b[data-nn-s12-variant-id="' + variantId + '"]'
  );
  var hasB = bSlides.length > 0;
  var galleryMode = hasB ? 'b' : 'a';
  sliderEl.setAttribute('data-nn-s12-gallery-mode', galleryMode);

  if (hasB) {
    document.body.setAttribute('nn-s-12-b-active', '');
    sliderEl.querySelectorAll('.product__media-slide.nn-s-12-ab-test-a').forEach(function (s) {
      s.classList.add('is-hidden-by-variant');
    });
    sliderEl.querySelectorAll('.product__media-slide.nn-s-12-ab-test-b').forEach(function (s) {
      s.classList.add('is-hidden-by-variant');
    });
    bSlides.forEach(function (s) {
      s.classList.remove('is-hidden-by-variant');
    });
    if (bSlides[0]) bSlides[0].classList.add('is-initial-select');
    var gallery = document.querySelector('.product__media');
    if (gallery) {
      gallery.querySelectorAll('.product__media-item.nn-s-12-ab-test-b').forEach(function (item) {
        item.classList.add('hidden');
      });
      var firstB = gallery.querySelector(
        '.product__media-item.nn-s-12-ab-test-b[data-nn-s12-variant-id="' + variantId + '"]'
      );
      if (firstB) firstB.classList.remove('hidden');
    }
  } else {
    document.body.removeAttribute('nn-s-12-b-active');
    sliderEl.querySelectorAll('.product__media-slide.nn-s-12-ab-test-b').forEach(function (s) {
      s.classList.add('is-hidden-by-variant');
    });
    nn_s12_applyAGallerySlides(variant);
  }

  nn_s12_unveilVisibleImages(sliderEl);
  updateMediaBadgeVisibility();

  if (skipFlickityRebuild) return;

  nn_s12_rebuildGallery();
}
// [nn-s-12 A/B TEST] End

// Desktop media grid: show only the media matching the selected variant
function normalizeMediaGridValue(value) {
  return (value || '').replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
}

function updateMediaGridForVariant(variant) {
  var grid = document.querySelector('.desktop-product__media-grid');
  if (!grid || !variant) return;

  var selectedValue = normalizeMediaGridValue((variant.options || []).filter(Boolean).join(' / '));
  var wrappers = Array.from(grid.querySelectorAll('.media-wrapper'));
  var matching = [];

  wrappers.forEach(function (wrapper) {
    var wrapperVariant = normalizeMediaGridValue(wrapper.dataset.variantAlt);
    var matchByData = wrapperVariant && wrapperVariant === selectedValue;
    var matchByImg = false;
    wrapper.querySelectorAll('img[alt]').forEach(function (img) {
      if (normalizeMediaGridValue(img.getAttribute('alt')) === selectedValue) matchByImg = true;
    });
    if (matchByData || matchByImg) matching.push(wrapper);
  });

  if (matching.length > 0) {
    wrappers.forEach(function (wrapper) { wrapper.classList.add('hidden'); });
    matching.forEach(function (wrapper) { wrapper.classList.remove('hidden'); });
  } else {
    wrappers.forEach(function (wrapper) { wrapper.classList.remove('hidden'); });
  }

  wrappers.forEach(function (wrapper) { wrapper.classList.remove('is-featured'); });
  var firstVisible = wrappers.find(function (wrapper) { return !wrapper.classList.contains('hidden'); });
  if (firstVisible) firstVisible.classList.add('is-featured');

  // Newly revealed wrappers still hold their d-src placeholder until the theme's
  // lazy-loader (lli, in foot-content.liquid) next runs on scroll/click/its 500ms
  // interval — force it now so images swap in immediately instead of looking stuck.
  if (typeof window.lli === 'function') {
    window.lli(0);
  }
}

// Inject Heading above Review Widget
var renderCount = 0;
const interval = setInterval(() => {
  if (renderCount > 20) {
    clearInterval(interval);
  }

  renderCount++;
  if (document.getElementById('judgeme_product_reviews')) {
    injectHeading();
    clearInterval(interval);
    
  }
}, 1000);

// Function to check and inject heading
function injectHeading() {
  
  const targetId = 'judgeme_product_reviews';
  const widget = document.getElementById(targetId);
  if (!widget) return false;

  var judgeMeReviewHeading = document.getElementById('judge_me_review_heading');

  console.log('judgeMeReviewHeading: ' + judgeMeReviewHeading);
  if (!judgeMeReviewHeading) return false;
  var judgeMeReviewHeadingValue = judgeMeReviewHeading.value?.trim();

  console.log('judgeMeReviewHeadingValue: ' + judgeMeReviewHeadingValue);
  if (judgeMeReviewHeadingValue == '') return false;

  const reviewContainer = widget.querySelector('.jdgm-rev-widg__reviews');
  const reviewItems = reviewContainer ? reviewContainer.querySelectorAll('.jdgm-rev') : [];
  
  if (reviewItems.length > 0 && !widget.querySelector('.reviews-heading')) {
    const headingWrapper = document.createElement('div');
    headingWrapper.className = 'judgeme-reviews-heading h3';

    // match anything inside brackets: [ ... ]
    const match = judgeMeReviewHeadingValue.match(/\[(.*?)\]/);

    if (match) {
      const content = match[1]; // text inside []

      // Replace ONLY the bracketed part, nothing else
      headingWrapper.innerHTML = judgeMeReviewHeadingValue.replace(
        /\[.*?\]/,
        `<font-miller class="h3-accent">${content}</font-miller>`
      );
    } else {
      // No brackets → keep original text 100% untouched
      headingWrapper.textContent = judgeMeReviewHeadingValue;
    }

    // headingWrapper.innerHTML = `<font-miller class="h3-accent">50.000</font-miller> zufriedenen Kundenbewertungen`;
    widget.insertBefore(headingWrapper, widget.firstChild);
    
    return true;
  }
  return false;
}

// Auto reinit countdown when HTML refreshes
setInterval(function() {
  if (document.querySelectorAll('.countdown-timer').length > 0) {
    document.querySelectorAll('.countdown-timer').forEach(el => el.timerActive = false);
  }
}, 1500);


